import { DataTable } from '@/components/ui/table/data-table';
import type { BroadcastSortDirection } from '@/modules/broadcast/contexts/BroadcastFilterContext';
import { columns } from '@/modules/broadcast/pages/Broadcasts/table/columns';
import { Toolbar } from '@/modules/broadcast/pages/Broadcasts/table/Toolbar';
import { Broadcast } from '@/shared/types/broadcast';

interface Props {
  data: Broadcast[];
  fetchNextPage: () => void;
  hasNextPage: boolean;
  currentPageIndex: number;
  setCurrentPageIndex: (index: number) => void;
  rowCount: number;
  sortDirection: BroadcastSortDirection;
  toggleSortDirection: () => void;
  onRowClick?: (broadcast: Broadcast) => void;
  getRowHref?: (broadcast: Broadcast) => string | null;
  onDeleteClick?: (broadcast_id: string) => void;
  canWrite?: boolean;
}

export function BroadcastTable({
  data,
  fetchNextPage,
  hasNextPage,
  currentPageIndex,
  setCurrentPageIndex,
  rowCount,
  sortDirection,
  toggleSortDirection,
  onRowClick,
  getRowHref,
  onDeleteClick,
  canWrite,
}: Props) {
  return (
    <DataTable.Root<Broadcast, unknown>
      columns={columns({ sortDirection, toggleSortDirection, onDeleteClick, canWrite })}
      data={data}
      pagination
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      currentPageIndex={currentPageIndex}
      setCurrentPageIndex={setCurrentPageIndex}
      rowCount={rowCount}
      onRowClick={onRowClick}
      getRowHref={getRowHref}
      enableRowHover
      resourceName="broadcast"
    >
      <DataTable.Toolbar>{() => <Toolbar />}</DataTable.Toolbar>
      <DataTable.Content />
      <DataTable.Pagination />
    </DataTable.Root>
  );
}
